module.exports = __webpack_public_path__ + "img/TECHCOMBANK.1fea594c.svg";